module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('block', {
    attrs: {
      "title": "Compétences"
    }
  }, [_c('div', {
    attrs: {
      "id": "skills"
    }
  }, _vm._l((_vm.skills), function(skill) {
    return _c('div', [_c('h2', [_vm._v(_vm._s(skill.title))]), _vm._v(" "), _vm._l((skill.items), function(item) {
      return [_c('list-item', [_c('span', {
        staticClass: "title"
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.description) ? _c('span', {
        staticClass: "description"
      }, [_vm._v("(" + _vm._s(item.description) + ")")]) : _vm._e()])]
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401cb13c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Skills.vue
// module id = 295
// module chunks = 1